import React, { FC, ReactNode } from 'react';
import { Card, List }           from 'semantic-ui-react';

import { CorvalAccount, CorvalOrganizationAccount } from '../../../../types';
import { LangService, UserService }                 from '../../../../services';
import { ORGANIZATIONAL_ROLE_INFO }                 from '../../../../constants/ProductEnums';
import { Gravatar }                                 from '../../../components/util/visual/Gravatar';

interface Props {
	account: Pick<CorvalAccount, 'firstName' | 'lastName' | 'emailAddress'>,
	organizationRole?: CorvalOrganizationAccount['organizationRole'],
	cardSize?: number,
	showDetails?: boolean,
	cardContent?: ReactNode,
}

const defaultProps: Props = {
	account:          null,
	organizationRole: null,
	showDetails:      true,
	cardContent:      null,
	cardSize:         240,
}

const UserProfileCard: FC<Props> = ( props ) => {
	
	let { account, organizationRole } = props;
	
	return (
		
		<Card fluid>
			
			<Gravatar size={ props.cardSize } user={ account }/>
			
			{ props.showDetails && (
				<Card.Content>
					<Card.Header>{ UserService.getUserName( account ) }</Card.Header>
					{ organizationRole && <Card.Meta>{ LangService.getTermFromDictionary( ORGANIZATIONAL_ROLE_INFO[ organizationRole ].LABEL ) }</Card.Meta> }
					
					<Card.Description>
						<List>
							
							<List.Item>
								<List.Icon name={ 'envelope' } color={ 'purple' }/>
								<List.Content>
									<List.Header><a href={ `mailto:${ account.emailAddress }` }>{ account.emailAddress }</a></List.Header>
								</List.Content>
							</List.Item>
						
						</List>
					</Card.Description>
				</Card.Content>
			) }
			
			{ props.cardContent && <Card.Content>{ props.cardContent }</Card.Content> }
		</Card>
	);
};

UserProfileCard.defaultProps = defaultProps;

export { UserProfileCard }
